import React from 'react';
import { colFormRef } from '../editor/plugins/collectionForm/consts';

const DocsLink = (props) => {
  const mystyle = {
    position: 'fixed',
  };

  if (props.link1 || props.link2) {
    return (
      <div className="text-left" style={mystyle}>
        {props.link1 ? (
          <>
            &nbsp;
            <a href={props.link1} target="_blank">
              <u>Tutorial 1</u>&nbsp;<i className="webconnect webconnect-box-arrow-up-right"></i>
            </a>
          </>
        ) : (
          ''
        )}

        {props.link2 ? (
          <>
            &nbsp;&nbsp;
            <a href={props.link2} target="_blank">
              <u>Tutorial 2</u>&nbsp;<i className="webconnect webconnect-box-arrow-up-right"></i>
            </a>
          </>
        ) : (
          ''
        )}
      </div>
    );
  } else {
    return '';
  }
};

export default DocsLink;
